import t from "../locales/translation";

interface Props {
  referral_url?: string;
}

const SuccessProcess = (props: Props) => {
  return (
    <div>
      <div
        className="Step_content__rT1v6"
        style={{ marginTop: "70px", marginBottom: "70px" }}
      >
        <div className="Section_container__1fP3-">
          <h1
            className="vas"
            style={{ fontWeight: "normal", fontSize: "17px" }}
          ></h1>
          <div style={{ display: "flex", gap: "5px" }}>
            <div className="Section_flexContainer__DrWgO">
              <div></div>
              <div className="ms-1">
                <span style={{ fontWeight: "normal", fontSize: "17px" }}></span>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              className="row ImageLabel_row__8rVUz"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="col ImageLabel_image_container__xsGyw">
                <img
                  className="vas ImageLabel_image__4lLzP"
                  src="https://opensooqui-new.s3.amazonaws.com/api/apiV/ios/1x/add_post_success/success.png"
                  alt={""}
                />
              </div>
            </div>
          </div>
          <div
            className="TextLabel_container__2gMMr mt-3 "
            style={{ marginBottom: "30px", marginTop: "30px" }}
          >
            <div className="row">
              <div className="col  d-flex justify-content-center">
                <div style={{ float: "left" }}></div>
                <div
                  className="ms-1"
                  style={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    color: "rgb(0,0,0)",
                    textAlign: "center",
                  }}
                >
                  {t.package_used}
                </div>
              </div>
            </div>
          </div>
          <div className="TextLabel_container__2gMMr mt-3 ">
            <div className="row">
              <div className="col  d-flex justify-content-center">
                <div style={{ float: "left" }}></div>
                <div
                  className="ms-1"
                  style={{
                    fontWeight: "normal",
                    fontSize: "17px",
                    color: "rgb(85 81 81)",
                    textAlign: "center",
                  }}
                >
                  {t.package_used_more_effective}
                </div>
              </div>
            </div>
          </div>

          <div className={`row mt-2`} style={{ width: "100%" }}>
            <div
              className={`col-11`}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <button
                onClick={() => {
                  // window.opener.location.reload(false);
                  if (props.referral_url)
                    window.parent.location.href = props.referral_url;
                  else window.parent.location.reload();
                }}
                className="vas"
                style={{
                  position: "relative",
                  border: "none",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  textAlign: "center",
                  transition: "0.2s all",
                  textDecoration: "none",
                  overflow: "hidden",
                  cursor: "pointer",
                  borderRadius: "8px",
                  backgroundColor: "#0179ff",
                  height: " 50px",
                  marginTop: "20px",
                  width: "30vh",
                }}
              >
                <div className={`row`}>
                  <div className={`col-12`}>
                    <div
                      style={{
                        display: "inline-block",
                        marginTop: "5px",
                      }}
                    >
                      {t.done}
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessProcess;
